import { IonGrid, IonRow } from '@ionic/react';
import { basketOutline } from 'ionicons/icons';
import { useEffect, useState } from 'react';

import SlideContent from '../../components/slide-content/SlideContent';
import { Empty } from '../../layouts/errors/Empty';
import { CartGetAction, ChangeCartPostAction, RemoveCartPostAction } from '../../redux/actions/Shop';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import CartItem from './components/CartItem';

import './Section1.css'

interface Props {
    setCartProducts: any,
    data: any
}

const Section1: React.FC<Props> = (props) => {
    const removeCartPost = useAppSelector(state => state.removeCartPost)
    const { form_loading, resp } = removeCartPost

    const changeCartPost = useAppSelector(state => state.changeCartPost)
    const { form_loading2, resp2 } = changeCartPost

    const [changeId, setChangeId] = useState('');

    const dispatch = useAppDispatch()

    const removeCart = (productId: any, color: any) => {
        setChangeId(productId + "," + color);

        dispatch(RemoveCartPostAction(productId, color))
    }

    const changeCart = (productId: any, color: string, quantity: any) => {
        setChangeId(productId + "," + color);

        dispatch(ChangeCartPostAction(productId, color, quantity));
    }

    useEffect(() => {
        if (resp != null && !form_loading) {
            props.setCartProducts(resp.items)

            window.cartTotal = resp.total;
        }
    }, [form_loading])

    useEffect(() => {
        if (resp2 != null && !form_loading2) {
            props.setCartProducts(resp2.items)
        }
    }, [form_loading2])

    return <SlideContent type="navbar">
        <div>
            <IonRow>
                <Empty text="سبد خرید خالی است!" icon={basketOutline} length={props.data.products?.length}>
                    {props.data.products?.map((item: any) => {
                        return <CartItem
                            key={`cart-item-${item.id}-${item.color}`}
                            id={item.id}
                            title={item.name}
                            color={item.color}
                            image={item.image}
                            price={item.totalPrice}
                            quantity={item.quantity}
                            max={item.availStocks}
                            changeId={changeId}
                            change={(quantity: any) => { changeCart(item.id, item.color, quantity) }}
                            remove={() => { removeCart(item.id, item.color) }}
                            loading={form_loading || form_loading2}
                            link={"/shop/" + item.id} />
                    })}
                </Empty>
            </IonRow>
        </div>
    </SlideContent>
}

export default Section1